import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TestDataManager } from "@/components/TestDataManager";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Wrench, ToggleLeft, Save } from "lucide-react";

export default function AdminMaintenance() {
  const [defs, setDefs] = useState([]);
  const [flags, setFlags] = useState({});
  const [savingFlags, setSavingFlags] = useState(false);

  const loadFlags = () => api.get("/feature-flags").then((r) => { setDefs(r.data.defs || []); setFlags(r.data.flags || {}); }).catch(() => {});
  useEffect(() => { loadFlags(); }, []);

  const saveFlags = async () => {
    setSavingFlags(true);
    try {
      const { data } = await api.put("/admin/feature-flags", { values: flags });
      setFlags(data.flags || {});
      toast.success("Visibilità funzionalità aggiornata");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore"); }
    finally { setSavingFlags(false); }
  };

  return (
    <div className="space-y-6" data-testid="admin-maintenance-page">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Impostazioni</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1 flex items-center gap-2"><Wrench className="w-7 h-7 text-primary" /> Manutenzione</h1>
        <p className="text-sm text-muted-foreground mt-1">Nascondi le funzionalità non ancora pronte e ripulisci i dati demo di prova.</p>
      </div>

      {/* Feature flags */}
      <Card className="glow-border p-5 space-y-4" data-testid="feature-flags-card">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div>
            <h2 className="font-head text-xl font-bold flex items-center gap-2"><ToggleLeft className="w-5 h-5 text-primary" /> Funzionalità visibili ai dealer</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Disattiva una voce per nasconderla dal menu dei dealer. Potrai riattivarla in qualsiasi momento.</p>
          </div>
          <Button onClick={saveFlags} disabled={savingFlags} className="gap-1" data-testid="feature-flags-save"><Save className="w-4 h-4" />{savingFlags ? "Salvo…" : "Salva"}</Button>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {defs.map((d) => (
            <div key={d.key} className="flex items-center justify-between rounded-lg border border-border p-3" data-testid={`feature-flag-${d.key}`}>
              <Label className="cursor-pointer">{d.label}</Label>
              <Switch checked={flags[d.key] !== false} onCheckedChange={(v) => setFlags((f) => ({ ...f, [d.key]: v }))} data-testid={`feature-flag-switch-${d.key}`} />
            </div>
          ))}
          {defs.length === 0 && <p className="text-sm text-muted-foreground">Caricamento…</p>}
        </div>
      </Card>

      <TestDataManager />
    </div>
  );
}
